import { ConfigPublic } from '@/common/config.public';
import { RouteBuilder, RouteInfo, RouteOptions } from '@/common/routes/RouteBuilder';
/**
 * @returns {Object} // ex {route: /posters/all, ...}
 */
export const RouteToAllPostersPage = (options?: RouteOptions) => {
  return RouteToPostersPage('all', options);
};

/**
 * @param pageName page for posters page
 * @returns {Object} // ex {route: /posters/${pageName}, ...}
 */
export const RouteToPostersPage = (pageName: string, options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: `/posters/${pageName}`, target: 'external' });
};

/**
 * @param searchPhrase page for search page related to searchPhrase
 * @returns {Object} // ex {route: /sr-artworks/${searchPhrase}, ...}
 */
export const RouteToSearchPage = (searchPhrase: string, options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: `/sr-artworks/${searchPhrase}`, target: 'external' });
};

/**
 * @returns '/cart'
 */
export const RouteToCartPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/cart', target: 'external' });
};

interface CollectionPageOptions extends RouteOptions {
  artistNick: string;
  collectionSlug: string;
}

/**
 * @returns '/marvel/anime-manga'
 */
export const RouteToCollectionPage = (options: CollectionPageOptions) => {
  const path = `/${options.artistNick}/${options.collectionSlug}`;
  return RouteBuilder({ ...options, path, target: 'external' });
};

interface ArtistPageParams extends RouteOptions {
  nick: string;
  licensed: boolean;
}

/**
 * @returns brand path '/licensed/marvel' or artist '/benny'
 */
export const RouteToArtistPage = (options: ArtistPageParams) => {
  let path: string;

  if (options.licensed) {
    path = `/licensed/${options.nick}`;
  } else {
    path = `/${options.nick}`;
  }

  return RouteBuilder({ ...options, path, target: 'external' });
};

interface SignInPageParams extends RouteOptions {
  /**
   * contextAction action id generated on backend
   */
  contextAction?: string;
}

/**
 * @returns '/auth/signin?contextAction=ctx'
 */
export const RouteToSignInPage = (options: SignInPageParams) => {
  const builtQuery = options.query ?? {};
  if (options.contextAction) {
    builtQuery.contextAction = options.contextAction;
  }
  return RouteBuilder({ ...options, path: '/auth/signin', target: 'external', query: builtQuery });
};

/**
 * @returns '/about-privacy'
 */
export const RouteToAboutPrivacyPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/about-privacy', target: 'external' });
};

/**
 * @returns '/about/3d-magnet'
 */
export const RouteTo3dMagnetLpPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/about/3d-magnet', target: 'external' });
};

/**
 * @returns '/about-mounting'
 */
export const RouteToAboutMountingPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/about-mounting', target: 'external' });
};

/**
 * @returns '/promo/curated-picks'
 */
export const RouteToPromoCuratedPicksPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/promo/curated-picks', target: 'external' });
};

/**
 * @returns '/shop-handbook
 */
export const RouteToShopHandbookPage = (options?: RouteOptions) => {
  return RouteBuilder({ ...options, path: '/shop-handbook', target: 'external' });
};

/**
 * @param reviewId id of trustpilot review
 * @returns 'https://www.trustpilot.com/reviews/reviewId'
 */
export const RouteToTrustPilotReview = (reviewId: string): RouteInfo => {
  return { route: `${ConfigPublic.TrustpilotBaseUrl}/reviews/${reviewId}`, target: 'external' };
};
